import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { AddListToOrderBatchInput } from './AddListToOrderBatchInput';
import { AddListToOrderBatchOutput } from './AddListToOrderBatchOutput';

export class AddListToOrderBatchService extends HttpServiceBase {

  handle = (input: AddListToOrderBatchInput): Promise<Result<AddListToOrderBatchOutput> | null> => {
    const promise = this.http.put<Result<AddListToOrderBatchOutput>, AddListToOrderBatchInput>(`${this.baseUrlSislogApi}/v2/order/batch/add/list`, input);
    return promise;
  }
}